import { useMemo } from 'react'
import useSlide2Data from './useSlide2Data'
import useSlide4Data from './useSlide4Data'

// שקף 5 — צרכים ומענים: הרכבה של נתוני שקף 2 ו-4 בלבד (React Query מאחד קריאות זהות)
const useSlide5Data = (assessmentFilters) => {
    const slide2 = useSlide2Data(assessmentFilters)
    const slide4 = useSlide4Data(assessmentFilters)

    return useMemo(() => ({
        needsCount: slide4.strugglingCount,
        strugglingTiers: slide4.strugglingTiers,
        completionRate: slide2.totalStudents
            ? Math.round((slide2.executedStudents / slide2.totalStudents) * 100)
            : 0,
        executedStudents: slide2.executedStudents,
        totalStudents: slide2.totalStudents,
        isLoading: slide2.isLoading || slide4.isLoading,
        isError: slide2.isError || slide4.isError
    }), [slide2, slide4])
}

export default useSlide5Data
